import { Modal } from "@/shared/ui/modal"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { SubmitHandler, useForm } from "react-hook-form"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { acknowledgePriceChange } from "@/shared/api/aviabooking/aviabooking"
import { closeAcknowledgeModal, selectBooking, selectIsAcknowledgeModalOpen, selectOnAcknowledge } from "../model"
import { ButtonLoader } from "@/shared/ui/button-loader"

export const AcknowledgePriceChangeModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsAcknowledgeModalOpen)
    const onAcknowledge = useAppSelector(selectOnAcknowledge)
    const booking = useAppSelector(selectBooking)

    const handleClose = () => {
        dispatch(closeAcknowledgeModal())
    }

    const onSubmit: SubmitHandler<{}> = async () => {
        try {
            await acknowledgePriceChange(booking.booking_id)
            notify.success('Изменение цены подтверждено')
            reset()
            onAcknowledge?.()
            handleClose()
        } catch(e: any) {
            notify.error(getErrorMessage(e?.response?.data?.error_id))
        }
    }

    const {
        handleSubmit,
        reset,
        formState: {
            isSubmitting
        }
    } = useForm()

    const prevPrice = booking?.price_prev
    const newPrice = booking ? booking.price_summary.total_fare : undefined
    const currency = booking?.price_summary?.currency

    return (
        <Modal
            isOpen={isOpen}
            title="Подтверждение изменения цены"
            onRequestClose={handleClose}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <div>
                    Цена на бронирование изменилась{prevPrice ? '' : ''}. {prevPrice ? `Было: ${prevPrice.toLocaleString()} ${currency}. ` : ''}Стало: {newPrice?.toLocaleString()} {currency}. Подтвердите, чтобы продолжить.
                </div>
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button" type="button">
                        Назад
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button inline-flex items-center justify-center gap-2" type="submit">
                        Подтвердить
                        {isSubmitting && <ButtonLoader />}
                    </button>
                </div>
            </form>
        </Modal>
    )
}
